import {
    CompleteLoggerConfig, LoggerContext, LoggerLevel, LogObject, Transform, TransformResult,
} from 'src/types';

export const applyDefaultsToMessage: Transform = (
    message: LogObject,
    context: LoggerContext,
    level: LoggerLevel,
    config: CompleteLoggerConfig,
): TransformResult => {
    if (!('level' in message)) {
        // eslint-disable-next-line no-param-reassign
        message.level = level;

        if (config.name) {
            // eslint-disable-next-line no-param-reassign
            message.name = config.name;
        }
    }

    return { context, message };
};
